import React, { useEffect, ReactNode } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { FaDollarSign } from 'react-icons/fa';
import { pageStateSelectors } from '../../../../../app/page/page-state/page-state.selectors';
import { initialSubscriptionPage } from '../../../../../app/page/subscription/subscription.actions';
import { authSelectors } from '../../../../../app/auth/auth.selectors';
import { useSelectWithParams } from '../../../../../utils/selector.utils';
import { PageLayout } from '../../../common/PageLayout';
import { Navigation, SubscriptionTab } from './Navigation';

type Props = {
  children: ReactNode;
  activeTab: SubscriptionTab;
};

export const SubscriptionLayout = ({ children, activeTab }: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const loggedUserisAdmin = useSelector(authSelectors.selectUserIsAdmin);
  const showLoader = useSelectWithParams(pageStateSelectors.selectPageInProgress, 'subscription');

  useEffect(() => {
    dispatch(initialSubscriptionPage());
  }, [dispatch]);

  return (
    <PageLayout showLoader={showLoader} showHide={true}>
      {!showLoader && (
        <div className="row mb-25">
          <div className="col-12">
            <div className="panel">
              <div className="panel-header no-border">
                <h2 className="bold">Settings</h2>
              </div>
              <div className="panel-body pt-0 ho-hover">
                <div className="border-radius-1 lightGray-bg p-2">
                  <div className="row">
                    <div className="col max-250">
                      {loggedUserisAdmin && (
                        <button
                          className="directory-button panel small-panel flex aic px-1 mb-1"
                          onClick={() => history.push('/settings/administration')}
                        >
                          <i className="icon-settings mr-1 blueGray" /> Administration
                        </button>
                      )}
                      <button
                        className="directory-button panel small-panel flex aic px-1 mb-1"
                        onClick={() => history.push('/settings/profile')}
                      >
                        <i className="icon-user mr-1 blueGray" /> Profile
                      </button>
                      {loggedUserisAdmin && (
                        <button
                          className="directory-button panel small-panel flex aic px-1 mb-1 active"
                          onClick={() => history.push('/settings/subscription')}
                        >
                          <FaDollarSign size={14} className="mr-1 blueGray" /> Subscription
                        </button>
                      )}
                    </div>
                    <div className="col">
                      <div className="panel w100">
                        <div className="panel-header no-border">
                          <h2 className="bold">Billing</h2>
                        </div>
                        <div className="panel-body pt-0">
                          <div className="border-radius-1 lightGray-bg p-2">
                            <div className="panel w100 p-3">
                              <div className="row">
                                <Navigation activeItem={activeTab} />
                                {children}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </PageLayout>
  );
};
